// Who may host an open house: active team Admins and Employees (never the
// outside-agent placeholder types 1/2). Extracted from ScheduleModal so the
// kiosk's "who's hosting?" gate and the scheduler agree on one list.
//
// Henry, 2026-09-06: an open house must always name a host, because every
// guest who signs in becomes that host's lead — a host-less open house would
// mint ownerless (invisible) leads.

export function eligibleHostingAgents(users) {
  return (users || [])
    .filter(
      (u) =>
        (u?.role === "Admin" || u?.role === "Employee") &&
        u?.type !== 1 &&
        u?.type !== 2,
    )
    .sort((a, b) =>
      `${a?.firstname || ""} ${a?.lastname || ""}`.localeCompare(
        `${b?.firstname || ""} ${b?.lastname || ""}`,
        undefined,
        { sensitivity: "base" },
      ),
    );
}

export const hostDisplayName = (u) =>
  `${u?.firstname || ""} ${u?.lastname || ""}`.trim();

// True once an open house has a resolvable host. The kiosk uses this to decide
// whether it must ask before letting sign-ins begin.
export const openHouseHasHost = (oh) =>
  !!String(oh?.hostingAgentId || "").trim();
